import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { FormRow, FormColumnMd } from "../../common/containers/formContainer";
import { TextInput } from "../../common/inputs";
import { GeneralButton } from "../../common/containers/button";
import useApi from "../../../hooks/useApi";
import MapEntity from "./mapEntity";
import CreateInstantEntity from "./CreateInstantEntity";
import LoadingSpinner from "../../common/loaders/loadingSpinner";
import AbnSearch from "./abnNameSearch";
import entityService from "../../../services/entityService";

function NewTrader({ entity_id, role, title, onCloseModal, source, handleSelectedItem = null, ...restProps }) {
  //------------------Custom hook to handle form data-----------------------------
  const [searchBy, setSearchBy] = useState(0);
  const [entitySearchKey, setEntitySearchKey] = useState("");
  const [abnSearchModal, setAbnSearchModal] = useState(false);
  const [entityData, setEntityData] = useState(null);
  const [asicResponse, setAsicResponse] = useState(null);
  const [request, setRequest] = useState(false);
  const [readonly, setReadonly] = useState(false);
  const [accountType, setAccountType] = useState("local");
  const [goNext, setGoNext] = useState(false);

  //------------Api Services--------------------------------------------
  const entitySearchApi = useApi(entityService.searchByAbn);

  const searchEntity = async () => {
    if (entitySearchKey === "") {
      toast.error("Please enter search key");
      return;
    }
    setAbnSearchModal(true);
  };
  const handleAbnSearch = async (result, type) => {
    setRequest(true);
    if (type === "asic") {
      setAsicResponse({
        entityFound: true,
        organisation: result.organisation,
        abn: result.abn,
      });
      setEntityData({ entityFound: true, type: "asic" });
    } else {
      const { data } = await entitySearchApi.request({
        abn_number: result.a_guid,
      });
      let result1 = data.result;
      if(data.success == true &&result1.entityFound == false){
        result1["type"] = "api";
        setEntityData(result1);
        return false;
      }
      result1.entityContacts.filter(item => item.is_primary == "yes").map((val, key) => {
        result1["contact_id"] = val.contact_id;
        val.isChecked = true
        return val;
      });
      result1["type"] = "api";
      setEntityData(result1);
    }
  };

  /* AccountType change checkbox */
  const accountTypeChange = async (event) => {
    const type = (event.target.checked) ? "intl" : "local";
    setAccountType(type);
    if (event.target.checked)
      setReadonly(true);
    else
      setReadonly(false);
  }

  useEffect(() => {
    if(restProps.data){
      setAccountType("intl");
      setRequest(true); 
      setGoNext(true);
    }
  }, [])

  return (
    <React.Fragment>
      {/*------------------Abn/Name Search------------------*/}
      <Modal
        show={abnSearchModal}
        onHide={(e) => setAbnSearchModal(false)}
        size="lg"
      >
        <AbnSearch
          searchBy={searchBy}
          entitySearchKey={entitySearchKey.trim()}
          handleAbnSearch={handleAbnSearch}
          onClose={(e) => setAbnSearchModal(false)}
        />
      </Modal>
      {/*---------------------------------------------------------*/}

      <Modal.Header closeButton>
        <h4 className="modal-title">
          {" "}
          {title == "DFDebtor" || title == "Debtor"
            ? "New DEBTOR"
            : "New SUPPLIER"}
        </h4>
      </Modal.Header>

      <Modal.Body>
        {entityData == null && (
          <div className="row mb-4">
            <div class="col-lg-12">
              {entitySearchApi.loading === true && <LoadingSpinner />}
              {!request && (
                <>
                  <FormRow className="m-t-lg">
                    <h6 className="m-md">
                      Please search using &nbsp;
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          id="orgname"
                          type="radio"
                          value="orgname"
                          class="custom-control-input"
                          onClick={(e) => setSearchBy(0)}
                          checked={searchBy === 0 ? true : false}
                        ></input>
                        <label class="custom-control-label" for="orgname">
                          Name
                        </label>
                      </div>
                      &nbsp;
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          id="orgnum"
                          type="radio"
                          value="orgnum"
                          class="custom-control-input"
                          onClick={(e) => setSearchBy(1)}
                          checked={searchBy === 1 ? true : false}
                        ></input>
                        <label class="custom-control-label" for="orgnum">
                          ABN
                        </label>
                      </div>
                    </h6>
                  </FormRow>

                  <FormRow>
                    <FormColumnMd col={8}>
                      <TextInput
                        name="abn_number"
                        placeholder={`Search by ${searchBy === 0 ? "Organisation name" : "ABN"
                          }`}
                        class="form-control input-sm float-left m-l-md"
                        value={entitySearchKey}
                        onChange={({ target }) =>
                          setEntitySearchKey(target.value)
                        }
                        type="normal"
                        readonly={readonly}
                      ></TextInput>
                    </FormColumnMd>

                    <FormColumnMd col={4}>
                      <GeneralButton
                        onClick={(e) => searchEntity()}
                        className="btn btn-primary "
                        faIcon="fa fa-search"
                        name="Search"
                        disabled={accountType === "intl"}
                      ></GeneralButton>
                    </FormColumnMd>
                  </FormRow>
                  <FormRow className="mt-4">
                    <FormColumnMd col={12}>
                      <div className="custom-control custom-checkbox custom-control-inline">
                        <input
                          id={`intCustomer`}
                          type="checkbox"
                          className="custom-control-input"
                          name="intCustomer"
                          onChange={(e) => accountTypeChange(e)}
                          checked={accountType === "intl" ? true : false}
                        />
                        <label className="custom-control-label" for={`intCustomer`}>
                          Sole trader, trust or international
                        </label>
                      </div>
                    </FormColumnMd>
                  </FormRow>
                  {accountType == "intl" &&
                    <FormRow className="mt-4">
                      <FormColumnMd col={12}>
                        <button className="btn btn-primary mr-4 pull-right" onClick={() => { setRequest(true); setGoNext(true); }}>
                          Next
                        </button>
                      </FormColumnMd>
                    </FormRow>
                  }
                </>
              )}
            </div>
          </div>
        )}
        {entityData !== null && entityData.entityFound && (
          <>

            {entityData.type == "api" ? (
              <MapEntity
                contacts={entityData.entityContacts}
                selected_contact={entityData.contact_id}
                role={role}
                entityDetails={entityData.entityDetails}
                entity_id={entity_id}
                onCloseModal={() => {
                  onCloseModal();
                }}
                source={source}
                title={title}
                handleSelectedItem={handleSelectedItem}
              />
            ) : (
              <CreateInstantEntity
                role={role}
                onCloseModal={() => onCloseModal()}
                searchData={{
                  abn: asicResponse.abn,
                  organisation: asicResponse.organisation,
                  searchBy: searchBy,
                }}
                entity_id={entity_id}
                source={source}
                title={title}
                accountType={accountType}
                handleSelectedItem={handleSelectedItem}
                data={restProps.data ? restProps.data : null}
              />
            )}
          </>
        )}
        {entityData !== null && entityData.entityFound == false &&(
          <>
          <p className="text-danger">
            {
              title == "DFDebtor" || title == "Debtor"
              ? "Debtor"
              : "Supplier"
            } already exist in fifopay database as a draft account.
          </p>
          </>
        )}
        {goNext &&
          <CreateInstantEntity
            role={role}
            onCloseModal={() => onCloseModal()}
            searchData={{}}
            entity_id={entity_id}
            source={source}
            title={title}
            accountType={accountType}
            handleSelectedItem={handleSelectedItem}
            data={restProps.data ? restProps.data : null}
          />
        }
      </Modal.Body>
    </React.Fragment>
  );
}

export default NewTrader;
